'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import { List, Map as ImmutableMap } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICardSection from 'UIComponents/card/UICardSection';
import UIFlex from 'UIComponents/layout/UIFlex';
import PropertyFormHeader from 'MeetingsLib/components/header/PropertyFormHeader';
import BookingFormFields from 'MeetingsLib/components/input/BookingFormFields';
import StepButtonsFooter from 'MeetingsLib/components/page/StepButtonsFooter';
import { canSubmitStagedPropertyForm as canSubmitStagedPropertyFormSelector } from 'MeetingsLib/selectors/AutoSubmitSelector';
import { getCustomParams as getCustomParamsSelector, getEvent as getEventSelector, shouldCenterPropertyForm as shouldCenterPropertyFormSelector, getOffline as getOfflineSelector, getRecaptchaEnabled } from 'MeetingsLib/selectors/BookInfoSelectors';
import { getStagedFormFieldValidation } from 'MeetingsLib/selectors/FormFieldValidationSelector';
import { getIsFetchingPublicAvailability } from 'MeetingsLib/selectors/RequestStatusSelectors';
import FormState from 'MeetingsLib/models/FormState';
import Branding from 'MeetingsBase/models/Branding';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
var PropertyForm = createReactClass({
  displayName: "PropertyForm",
  propTypes: {
    // passed
    branding: PropTypes.instanceOf(Branding).isRequired,
    canSubmitInitialPropertyForm: PropTypes.bool.isRequired,
    compact: PropTypes.bool,
    goToPreviousStep: PropTypes.func.isRequired,
    submittingMeeting: PropTypes.bool,
    //loaded
    canSubmitStagedPropertyForm: PropTypes.bool,
    centerPropertyForm: PropTypes.bool,
    dateTime: PropTypes.number.isRequired,
    formFields: PropTypes.instanceOf(List).isRequired,
    stagedFormState: PropTypes.instanceOf(FormState),
    formStateValidation: PropTypes.instanceOf(ImmutableMap).isRequired,
    recaptchaEnabled: PropTypes.bool.isRequired,
    legalConsentEnabled: PropTypes.bool.isRequired,
    offline: PropTypes.bool,
    setFormValue: PropTypes.func.isRequired,
    setFormState: PropTypes.func.isRequired,
    resetFormState: PropTypes.func.isRequired,
    userTimezone: PropTypes.string.isRequired,
    isRescheduling: PropTypes.bool
  },
  shouldCenterForm: function shouldCenterForm() {
    var _this$props = this.props,
        compact = _this$props.compact,
        centerPropertyForm = _this$props.centerPropertyForm;
    return !compact && centerPropertyForm;
  },
  isLastStep: function isLastStep() {
    var _this$props2 = this.props,
        legalConsentEnabled = _this$props2.legalConsentEnabled,
        isRescheduling = _this$props2.isRescheduling;
    return isRescheduling || !legalConsentEnabled;
  },
  handleGoToPreviousStep: function handleGoToPreviousStep() {
    var _this$props3 = this.props,
        resetFormState = _this$props3.resetFormState,
        goToPreviousStep = _this$props3.goToPreviousStep;
    resetFormState();
    goToPreviousStep();
  },
  renderFormFields: function renderFormFields() {
    var _this$props4 = this.props,
        formFields = _this$props4.formFields,
        stagedFormState = _this$props4.stagedFormState,
        formStateValidation = _this$props4.formStateValidation,
        setFormValue = _this$props4.setFormValue,
        recaptchaEnabled = _this$props4.recaptchaEnabled,
        isRescheduling = _this$props4.isRescheduling;
    return /*#__PURE__*/_jsx(UIFlex, {
      className: "p-x-10",
      direction: "column",
      align: "stretch",
      children: /*#__PURE__*/_jsx(BookingFormFields, {
        centerPropertyForm: this.shouldCenterForm(),
        formFields: formFields,
        formState: stagedFormState,
        formStateValidation: formStateValidation,
        setFormValue: setFormValue,
        recaptchaEnabled: recaptchaEnabled,
        isLastStep: this.isLastStep(),
        disabled: isRescheduling
      })
    }, "fields");
  },
  renderFormHeader: function renderFormHeader() {
    var _this$props5 = this.props,
        offline = _this$props5.offline,
        userTimezone = _this$props5.userTimezone,
        dateTime = _this$props5.dateTime;
    return /*#__PURE__*/_jsx(PropertyFormHeader, {
      centerPropertyForm: this.shouldCenterForm(),
      offline: offline,
      userTimezone: userTimezone,
      dateTime: dateTime,
      handleGoToPreviousStep: this.handleGoToPreviousStep
    });
  },
  renderFormButtons: function renderFormButtons() {
    var _this$props6 = this.props,
        branding = _this$props6.branding,
        compact = _this$props6.compact,
        submittingMeeting = _this$props6.submittingMeeting,
        canSubmitStagedPropertyForm = _this$props6.canSubmitStagedPropertyForm,
        setFormState = _this$props6.setFormState,
        stagedFormState = _this$props6.stagedFormState,
        offline = _this$props6.offline,
        isRescheduling = _this$props6.isRescheduling;
    return /*#__PURE__*/_jsx(StepButtonsFooter, {
      branding: branding,
      compact: compact,
      submittingMeeting: submittingMeeting,
      canProceed: isRescheduling || canSubmitStagedPropertyForm,
      tooltipTitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "buttons.tooltip.formIncompleteOrHasErrors"
      }),
      goToPreviousStep: this.handleGoToPreviousStep,
      goToNextStep: function goToNextStep() {
        return setFormState(stagedFormState);
      },
      isLastStep: this.isLastStep(),
      offline: offline
    }, "buttons");
  },
  render: function render() {
    var _this$props7 = this.props,
        canSubmitInitialPropertyForm = _this$props7.canSubmitInitialPropertyForm,
        recaptchaEnabled = _this$props7.recaptchaEnabled;
    return /*#__PURE__*/_jsxs(UICardWrapper, {
      className: "flex-column min-height-0",
      children: [/*#__PURE__*/_jsxs(UICardSection, {
        className: "flex-column min-height-0 p-all-0",
        scrollable: true,
        children: [this.renderFormHeader(), canSubmitInitialPropertyForm && !recaptchaEnabled ? /*#__PURE__*/_jsx(UILoadingSpinner, {
          size: "medium",
          grow: true
        }) : this.renderFormFields()]
      }), (!canSubmitInitialPropertyForm || recaptchaEnabled) && this.renderFormButtons()]
    });
  }
});
export default connect(function (state) {
  return {
    canSubmitStagedPropertyForm: canSubmitStagedPropertyFormSelector(state),
    centerPropertyForm: shouldCenterPropertyFormSelector(state),
    dateTime: getEventSelector(state).dateTime,
    formFields: getCustomParamsSelector(state).formFields,
    stagedFormState: state.stagedFormState,
    formStateValidation: getStagedFormFieldValidation(state),
    isFetchingPublicAvailability: getIsFetchingPublicAvailability(state),
    recaptchaEnabled: getRecaptchaEnabled(state),
    legalConsentEnabled: getCustomParamsSelector(state).legalConsentEnabled,
    offline: getOfflineSelector(state),
    userTimezone: state.userTimezone,
    isRescheduling: state.isRescheduling
  };
}, FormActions)(PropertyForm);